<template>
    <div class="header-container">
        <a-layout-header class="header" :style="{ position: 'fixed', zIndex: 1000, width: '100%' }">
            <div class="content">
                <div class="sitename">
                    <span>{{ title }}</span> 
                </div>
                <div class="userinfo">
                    <div class="back-website" title="返回站点" @click="handleBack">
                        返回站点
                    </div>
                    <a-dropdown :trigger="['click']">
                        <div class="username overhide">
                            {{ userinfo.nickname }}
                        </div>
                    </a-dropdown>
                    <div class="logout" title="安全退出" @click="logOut">
                        <poweroff-outlined />
                    </div>
                </div>
            </div>
        </a-layout-header>

        <a-modal v-model:visible="visible" title="个人资料" @ok="handleOk" @cancel="handleCancel" width="100%" wrapClassName="full-modal">
            <a-spin tip="Loading..." :spinning="loading">
                <a-form ref="formData" :rules="formDataRules" layout="horizontal" :model="formData" :label-col="labelCol" :wrapper-col="wrapperCol">
                    <a-row justify="center">
                        <a-col :xs="24" :lg="8">
                            <a-form-item label="昵称" name="nickname">
                                <a-input v-model:value="formData.nickname" placeholder="请输入昵称" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row justify="center">
                        <a-col :xs="24" :lg="8">
                            <a-form-item label="手机号" name="mobile">
                                <a-input v-model:value="formData.mobile" :disabled="true" placeholder="请输入手机号" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-spin>
        </a-modal>

        <a-modal v-model:visible="visiblePwd" title="修改密码" @ok="handleDoChangePwd" @cancel="handleCancelChangePwd" width="100%" wrapClassName="full-modal">
            <a-spin tip="Loading..." :spinning="loading">
                <a-form ref="formData" :rules="formDataRules" layout="horizontal" :model="formData" :label-col="labelCol" :wrapper-col="wrapperCol">
                    <a-row justify="center">
                        <a-col :xs="24" :lg="8">
                            <a-form-item label="新密码" name="password">
                                <a-input v-model:value="password" placeholder="请输入新密码" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-spin>
        </a-modal>

        <Sms :visible="smsVisible" :mobile="userinfo.mobile" @ok="handleChangePwd()" @close="showSms()" />


    </div>
</template>


<script>
    import { UpdateUser, ChangePasswd } from '@/api/users';
    import { IsValidateMobile } from '@/tool/common';
    import Sms from '@/components/sms/index.vue'
    export default {
        components: {
            Sms
        },
        data() {
            return {
                labelCol: { span: 5 },
                wrapperCol: { span: 14 },
                visible: false,
                loading: false,
                basic: {},
                formDataRules: {
                    mobile: [
                        { required: true, message: "请输入手机号" }
                    ],
                    nickname : [
                        { required: true, message: "请输入昵称" }
                    ],
                },
                title: this.$baseconfig.sitename,
                userinfo: this.$store.state.userinfo || {},
                formData: JSON.parse(JSON.stringify(this.$store.state.userinfo)),

                visiblePwd: false,
                smsVisible: false,
                password: ""
            }
        },
        created() {
            
        },
        methods: {
            handleDoChangePwd() {
                let _this = this
                var password = _this.password
                if(!password) {
                    _this.$message.error({
                        duration: 1,
                        content: "密码不能为空",
                    });
                    return
                }
                if(_this.loading) {
                    return
                }
                _this.loading = true
                ChangePasswd({
                    password: password
                }).then((result) => {
                    _this.loading = false
                    if(result.code) {
                        _this.$message.error({
                            duration: 1,
                            content: result.message,
                        });
                        return
                    }
                    _this.visiblePwd = false
                    _this.$message.success({
                        duration: 1,
                        content: result.message + "，正在退出...",
                    });
                    _this.doLogOut()
                })
            },
            handleCancelChangePwd() {
                let _this = this
                _this.smsVisible = false
            },
            showSms() {
                let _this = this
                _this.smsVisible = !_this.smsVisible
            },
            handleChangePwd() {
                let _this = this
                if(_this.userinfo.mobile == "") {
                    _this.$message.error({
                        content: "请先绑定手机号"
                    })
                    return
                }
                let isVali = IsValidateMobile()
                if(!isVali) {
                    _this.showSms()
                    return
                }
                _this.visiblePwd = true
            },
            handleCancel() {
                let _this = this
                _this.formData = JSON.parse(JSON.stringify(this.$store.state.userinfo))
            },
            handleOk() {
                let _this = this
                _this.$refs['formData'].validate().then(() => {
                    if(_this.loading) {
                        return
                    }
                    _this.loading = true
                    UpdateUser(_this.formData).then((result) => {
                        _this.loading = false
                        if(result.code == 0) {
                            _this.$message.success({
                                content: result.message,
                                onClose() {
                                    location.reload()
                                }
                            });
                        }else {
                            _this.$message.error({
                                duration: 1,
                                content: result.message,
                            });
                        }
                    })
                }).catch((error) => {
                    console.log(error)
                })
            },
            doLogOut() {
                let _this = this
                _this.$store.dispatch("Logout").then((result) => {
                    _this.$message.success({
                        duration: 1,
                        content: result.message,
                        onClose() {
                            location.href = "/"
                        }
                    })
                })
            },
            handleBack() {
                window.location.href = "/"
            },
            logOut() {
                let _this = this
                _this.$confirm({
                    title: "确定退出当前账号吗？",
                    okText: '确认',
                    cancelText: '取消',
                    onOk() {
                        _this.doLogOut()
                    }
                });
            }
        }
    }
</script>

<style lang="less" scoped>
.header-container {
    user-select: none;
    .ant-layout-header {
        padding: 0 !important;
        height: 50px !important;
        line-height: 50px !important;
    }
    .content {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        .sitename {
            height: 100%;
            color: #FFF;
            padding: 0 10px;
            font-weight: bold;
        }

        @media screen and (orientation: landscape){
            .sitename {
                width: 200px;
                text-align: center;
            }
        }
        .userinfo {
            color: #FFF;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            .back-website {
                padding: 0 10px;
                cursor: pointer;
            }
            .username {
                max-width: 100px;
                padding: 0 10px;
                text-align: center;
                cursor: pointer;
            }
            .logout,.recharge {
                height: 100%;
                width: 50px;
                text-align: center;
                cursor: pointer;
                transition-duration: .5s;
            }
            .back-website:hover,.username:hover,.logout:hover,.recharge:hover {
                background-color: #44505E;
                transition-duration: .5s;
            }
        }
    }
}
</style>

